import { NgModule } from '@angular/core';

import { MasterMasterGroupsActions } from './master-master-groups.actions';

@NgModule({
  providers: [
    MasterMasterGroupsActions
  ]
})
export class MasterMasterGroupsActionsModule {}
